<template>
  <div>
    <next
      :session="question"
      @onAnswer="submitAnswer"
      @onBack="back"
      v-if="question.answers.length < 11"
    />
    <choose-common
      :session="question"
      @onAnswer="submitAnswer"
      @onBack="back"
      v-else
    />
  </div>
</template>

<script>
import { mapState } from "vuex"
import Next from "../../components/symtom-checker/next.vue"
import ChooseCommon from "../../components/symtom-checker/choose-common.vue"
export default {
  async mounted() {},
  components: {
    Next,
    ChooseCommon,
  },
  computed: {
    ...mapState({
      question: (state) => state.sc.question,
      answer: (state) => state.sc.answer,
      session_id: (state) => state.sc.session_id,
    }),
  },
  methods: {
    async submitAnswer(val) {
      await this.$store.dispatch("sc/next", val)
      this.$forceUpdate()
    },
    async back() {
      await this.$store.dispatch("sc/back")
      this.$forceUpdate()
    },
  },
}
</script>

<style lang="scss">
.progress-bar {
  background: #fff;
  border-radius: 4px;
      height: 9px;
  .progress{
    background: transparent linear-gradient(90deg, #FFA25C 0%, #D258FD 71%, #BC00FF 100%) 0% 0% no-repeat padding-box;
    height: 100%;
    border-radius: 4px;
  }
}
</style>
